import { Button, Col, Modal, Row, Alert } from "antd";
import InputBox from "components/InputBox";
import SpinBox from "components/SpinBox";
import React, { useState } from "react";
import * as API from "utils/api";

export default function Index({
  isOpen,
  onCancel,
  loading,
  onSubmit,
  nameError,
  name,
  handleChange,
}) {
  return (
    <div>
      <Modal
        visible={isOpen}
        onCancel={onCancel}
        footer={null}
        centered={true}
        closable={true}
        width={550}
        className="report-modal"
        title={"Create Pricing Group"}
      >
        <Row type="flex" align="middle" className="report-body">
          <Row
            type="flex"
            justify="space-between"
            align="middle"
            className="main-info"
          >
            <SpinBox loading={loading}>
              <Row>
                <span>Name</span>
              </Row>
              <Col md={24}>
                <InputBox name="name" value={name} onChange={handleChange} />
                <Row>
                  {nameError && (
                    <Alert
                      type="error"
                      message={nameError}
                      banner
                      style={{ marginTop: 15 }}
                    />
                  )}
                </Row>
              </Col>
            </SpinBox>
          </Row>

          <Button
            type="primary"
            size="large"
            className="green-btn button"
            onClick={onSubmit}
          >
            Create
          </Button>
        </Row>
      </Modal>
    </div>
  );
}
